import typesStageSubPhase from './typesStageSubPhase';

/**
 * type Phase {
 *     name: string,
 *     description: string,
 *     subPhases: SubPhase[]
 * }
 * type SubPhase {
 *     name: string,
 *     price: string,
 *     stages: { [key: string]: string },
 *     results: string[],
 *     risks: string[]
 * }
 */
export default [
    {
        name: 'Кому и зачем нужен сервис',
        description: 'Выявление проблем и потенциальных клиентов',
        subPhases: [
            {
                name: 'Конкуренты, аналоги, бенчмарки',
                price: {
                    from: 'От 350 т.р.',
                    to: 'до 900 т.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: 'Анализ конкурентного окружения, сравнение функционала продуктов. Выделение трендов и лучших практик, оценка рынка готовых решений. Сегментация по типам решений, поиск свободных продуктовых ниш. Общее представление о рынке.',
                    [typesStageSubPhase.whyNeeded]: 'Понять, какие решения есть на рынке, и как они отвечают текущим потребностям пользователя. Выявить минимальные требования к решению.',
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Позволяет понять необходимое функциональное наполнение продукта, приоритизировать бэклог, отстроиться от конкурентов в продуктовом плане.',
                    [typesStageSubPhase.whatResultStage]: ['Библиотека решений и кейсов конкурентов;', 'Карта лучших практик и трендов;', 'Сравнение конкурентов по функциональным и коммуникационным параметрам продуктов.'],
                },
                results: [
                    'Понимание, как потребности клиентов сейчас закрываются конкурентами на рынке;',
                    'Примеры сценариев и функций, реализованных у конкурентов.',
                ],
                risks: [
                    'Решение будет не актуальным, не уникальным, механики разработки — не трендовыми, а представление о конкурентах и рынке — неверным. ',
                ],
            },
            {
                name: 'Исследование пути клиента',
                price: {
                    from: 'От 550 т.р.',
                    to: 'до 850 т.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: 'Серия интервью с представителями целевой аудитории с использованием проективных методик, направленных на описание рациональных и эмоциональных составляющих клиентского опыта.',
                    [typesStageSubPhase.whyNeeded]: 'Выявить ожидания, проблемы и мотивы ЦА будущего сервиса, и определить, где сервис наиболее востребован.\n\nДля готового продукта — выявить проблемы или зоны, которые требуют доработки.',
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Обобщает всю ключевую информацию о пользователе и его запросах и позволяет руководствоваться данными, а не представлениями команды о том, что нужно клиенту.',
                    [typesStageSubPhase.whatResultStage]: 'Карта клиентских путей с ожиданиями, проблемами и мотивами различных подгрупп целевой аудитории и рекомендации по проектированию и развитию продукта на этой основе.',
                },
                results: [
                    'Понимание различных типов целевой аудитории;',
                    'Данные об их ключевых проблемах и мотивах, связанных с продуктом;',
                    'Описание сценариев, связанных с продуктом.',
                ],
                risks: [
                    'Риск сделать ненужный продукт, который не отвечает запросам пользователя и не встраивается в его сценарии.',
                ],
            },
        ],
    },
    {
        name: 'Прототипи&shy;ро&shy;вание',
        description: 'Собственная методология дизайн-спринтов',
        subPhases: [
            {
                name: 'Focus-спринт',
                price: {
                    from: 'От 900 т.р.',
                    to: 'до 1,3 млн.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: 'Проработка и тестирование продуктовых и бизнес-гипотез на реальных пользователях без создания MVP и затрат на долгие циклы разработки за 2 недели с помощью подхода Google Ventures.',
                    [typesStageSubPhase.whyNeeded]: ['Сэкономить на дизайне и разработке;', 'Ускорить выход на рынок;', 'Повысить слаженность продуктовой команды;', 'Выявить дополнительные бизнес-возможности на ранних стадиях проекта.'],
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Этот этап позволяет быстро проработать новый проект или перезапустить существующий. Эффективно перейти от этапа исследования к проектированию продукта.',
                    [typesStageSubPhase.whatResultStage]: ['Ответ на проектные гипотезы;', 'Дизайн-концепция и цифровой прототип;', 'Наглядные результаты тестов пользователей;', 'План развития продукта.'],
                },
                results: [
                    'Интерактивный прототип прототип в FIGMA;',
                    'Результат спринта на онлайн-доске Miro;',
                    'Презентация итогового отчета по дизайн-спринту.',
                ],
                risks: [
                    'Разница в видении членов команды;',
                    'Лишние траты на дизайн и разработку;',
                    'Нет теста гипотез роста и обратной связи пользователей.',
                ],
            },
            {
                name: 'Focus+ “Продуктовая стратегия”',
                price: {
                    from: 'От 1,3 млн.р.',
                    to: 'до 2 млн.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: 'Focus+ — от идеи до продуктовой стратегии и трафик тестов за 4 недели.',
                    [typesStageSubPhase.whyNeeded]: 'Количественное тестирование гипотез роста или нового продукта, сбор данных для формирования юнит-экономики.',
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Возможность количественно протестировать гипотезы роста или нового продукта, и собрать данные, чтобы сформировать юнит-экономику.',
                    [typesStageSubPhase.whatResultStage]: ['Продуктовая стратегия;', 'А/б или количественные трафик-тесты;', 'Проверка гипотез роста, ценностного предложения;', 'Первые реальные пользователи и продажи.'],
                },
                results: [
                    'Интерактивный прототип прототип в FIGMA;',
                    'Презентация итогового отчета по дизайн-спринту;',
                    'Онлайн-доска Miro с результатами спринта Focus+.',
                ],
                risks: [
                    'Разница в видении членов команды;',
                    'Лишние траты на дизайн и разработку;',
                    'Нет теста гипотез роста и обратной связи пользователей.',
                ],
            },
        ],
    },
    {
        name: 'Проверка гипотез',
        description: 'Подтверждение проблемы и наличия клиентов, готовых платить за решение',
        subPhases: [
            {
                name: 'Конкуренты, аналоги, бенчмарки',
                price: {
                    from: 'От 350 т.р.',
                    to: 'до 900 т.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: 'Проверка гипотез с помощью анализа конкурентного окружения, функционала продуктов, трендов, лучших практик и рынка готовых решений. Сегментация конкурентов, поиск свободных продуктовых ниш.',
                    [typesStageSubPhase.whyNeeded]: ['Сверить гипотезы с решениями на рынке;', 'Понять, как удовлетворить потребности пользователя;', 'Приоритизировать разработку — определить гигиенический минимум и опциональные части.'],
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Позволяет понять необходимое функциональное наполнение продукта, приоритизировать бэклог, создать конкурентное преимущество.',
                    [typesStageSubPhase.whatResultStage]: ['Библиотека решений и кейсов конкурентов;', 'Карта лучших практик и трендов;', 'Сравнение конкурентов по функциональным и коммуникационным параметрам продуктов.'],
                },
                results: [
                    'Понимание, как потребности клиентов сейчас закрываются конкурентами на рынке;',
                    'Примеры сценариев и функций, реализованных у конкурентов.',
                ],
                risks: [
                    'Решение будет не актуальным, не уникальным, механики разработки — нетрендовыми, а представление о конкурентах и рынке — неверным.',
                ],
            },
            {
                name: 'Глубокое изучение ЦА',
                price: {
                    from: 'От 700 т.р.',
                    to: 'до 1,1 млн.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: 'Сочетание глубинных интервью, анализа социальных медиа и онлайн-опроса целевой аудитории.',
                    [typesStageSubPhase.whyNeeded]: 'Уточнение портрета и запросов целевой аудитории, чтобы понять, кому нужен наш продукт, как и в каких каналах можно коммуницировать о нем с потенциальным потребителем.',
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Позволяет снять множество вопросов о ЦА и продукте, которые появляются по итогам спринта.',
                    [typesStageSubPhase.whatResultStage]: ['Описание ЦА по подгруппам, выделение приоритетных подгрупп ЦА и особенностей продукта, которые будут для них наиболее ценными.'],
                },
                results: [
                    'Портреты сегментов ЦА;',
                    'Важные сегменты ЦА;',
                    'Оценка важнейших проблем и мотивов ЦА;',
                    'Каналы коммуникации, важные для ЦА.',
                ],
                risks: [
                    'Потеря денег и времени на разработку продукта не под ту ЦА или с неподходящим функционалом.',
                ],
            },
            {
                name: 'Быстрый опрос&nbsp;для теста',
                price: {
                    from: 'От 250 т.р.',
                    to: 'до 450 т.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: 'Быстрый онлайн-опрос по небольшой выборке.',
                    [typesStageSubPhase.whyNeeded]: 'Быстрая проверка продуктовых гипотез.',
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Поможет принять решение, ускорит процесс создания прототипа или доработки сервиса.',
                    [typesStageSubPhase.whatResultStage]: ['Приоритизация проблем, гипотез или фичей.'],
                },
                results: [
                    'Рейтинг лучших решений и идей.',
                ],
                risks: [
                    'Потеря денег и времени на разработку нерелевантного продукта.',
                ],
            },
            {
                name: 'Определение ЦА\n(Спецпроекты)',
                price: {
                    from: 'От 100 т.р.',
                    to: 'до 4 млн.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: 'Оценка интереса, конверсии или оттока выбранной целевой аудитории в разрезе реального продукта.\n\nВыявление потенциальной аудитории, которая изначально не принималась во внимание.',
                    [typesStageSubPhase.whyNeeded]: 'Чтобы понимать, насколько продукт нужен намеченной ЦА, выявлять наиболее перспективные аудитории, методы работы с ними и ситуации, в которых аудитория откажется от использования продукта.',
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Возможность более сознательно подходить к работе с аудиторией, выстраивать пользовательские пути, каналы коммуникации и распространения продукта.',
                    [typesStageSubPhase.whatResultStage]: ['Структурный анализ потенциальной и реальной аудитории, развёрнутый путь клиента с конверсиями по аудиториям.'],
                },
                results: [
                    'Структурный анализ ЦА;',
                    'Наиболее эффективные каналы коммуникации;',
                    'Рекомендации по доработке пользовательского пути.',
                ],
                risks: [
                    'Неправильный выбор ЦА или потеря конверсии могут снизить востребованность продукта на рынке или усложнить путь к его развитию.',
                ],
            },
            {
                name: 'Попытка продать (Спецпроект)',
                price: {
                    from: 'От 100 т.р.',
                    to: 'до 4 млн.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: 'Имитация продажи продукта до его запуска, показывает реальный интерес пользователей, готовых купить продукт здесь и сейчас и подсвечивает места провала конверсий — условия, цена, сроки доставки и т.д.',
                    [typesStageSubPhase.whyNeeded]: 'Понять, насколько продукт нужен рынку в идеальном наборе параметров. Дешевый способ проверить гипотезы не абстрактно, а с условием намерения получить продукт, но при этом без производства.',
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Понимание, что ЦА готова купить продукт, а не просто заинтересована. Можно запускать в формате А/Б тестов и выявлять, что нужнее реальным покупателям.',
                    [typesStageSubPhase.whatResultStage]: ['Структурный анализ готовых к покупке пользователей и конверсионного пути.'],
                },
                results: [
                    'Системный анализ конверсий;',
                    'Точки отказа в пользовательском пути;',
                    'Рекомендации по повышению конверсии.',
                    // 'Проверка на востребованность у реальных покупателей;',
                    // 'Анализ аудитории, которая преимущественно покупает продукт.',
                ],
                risks: [
                    'Потенциально нужный и интересный продукт может оказаться невостребованным среди платежеспособной аудитории. ',
                ],
            },
            {
                name: 'Определение цены (Спецпроект)',
                price: {
                    from: 'От 100 т.р.',
                    to: 'до 4 млн.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: 'С помощью одного или нескольких методов мы определяем цену с наибольшим объемом потенциальной выручки.',
                    [typesStageSubPhase.whyNeeded]: 'Выставить цену, отвечающую главному приоритету на текущий момент: максимизация прибыли, увеличение количества потребителей, выявление порога цены согласия у покупателей и многое другое.',
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Позволяет выстроить ценообразование с максимальным учетом текущих целей компании.',
                    [typesStageSubPhase.whatResultStage]: ['Сравнительный анализ поведения покупателей при разном ценообразовании.'],
                },
                results: [
                    'Определение, нужен ли продукт платежеспособной аудитории;',
                    'Цена, максимизирующая прибыль;',
                    'Выявленный порог согласия клиента.',
                ],
                risks: [
                    'Финансовые и имиджевые потери. Высокая цена может отвернуть от покупки, а низкая — повредить представлениям о качестве продукта.',
                ],
            },
            {
                name: 'Супермаркет фичей (Спецпроект)',
                price: {
                    from: 'От 100 т.р.',
                    to: 'до 4 млн.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: 'Конструктор для ЦА, где пользователи сами «собирают» тариф или пакет необходимых опций в продукте. Анализируя выбор аудитории, можно сделать вывод о самых востребованных функциях продукта.',
                    [typesStageSubPhase.whyNeeded]: 'Он позволяет проверить гипотезы о востребованных и второстепенных функциях продукта на реальных пользователях.',
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Поняв мнение пользователей в реальных, а не в стерильных условиях исследований, можно скорректировать планы по развитию продукта и его наполнению.',
                    [typesStageSubPhase.whatResultStage]: ['Отчёт со сравнительной характеристикой востребованности функций продукта.'],
                },
                results: [
                    'Выявленные потребности аудитории;',
                    'Сформированный приоритет по планируемому функционалу.',
                ],
                risks: [
                    'Можно наполнить продукт ненужными опциями, потратить ресурсы на их развитие и проиграть конкурентную борьбу.',
                ],
            },
        ],
    },
    {
        name: 'Проектиро&shy;ва&shy;ние и дизайн',
        description: 'Проверка гипотез, создание userflow и интерфейсов',
        subPhases: [
            {
                name: 'Проработка сценариев. Мокапы',
                price: {
                    from: 'От 400 т.р.',
                    to: 'до 1,9 млн.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: 'Внедрение проверенных гипотез в продукт – проработка пользовательских сценариев в формате мокапов.',
                    [typesStageSubPhase.whyNeeded]: 'Чтобы решить, как функционально реализовывать гипотезы.',
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Выстраивает наглядную картину взаимодействия с продуктом.',
                    [typesStageSubPhase.whatResultStage]: ['User screen flow или кликабельный прототип из мокапов.'],
                },
                results: [
                    'УТП продукта;',
                    'Готовые пользовательские сценарии;',
                    'Зафиксированные фичи, которые войдут в MVP.',
                ],
                risks: [
                    'Упущенные детали придется исправлять при создании макетов или на разработанном продукте — это гораздо дороже и дольше.',
                ],
            },
            {
                name: 'Визуальная концепция',
                price: {
                    from: 'От 100 т.р.',
                    to: 'до 600 т.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: 'Создание запоминающегося визуального образа продукта.',
                    [typesStageSubPhase.whyNeeded]: 'Для обретения своего “лица” и характера продукта на рынке.',
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Задает визуальное единообразие для всего продукта.',
                    [typesStageSubPhase.whatResultStage]: ['Визуальный стиль всего продукта.'],
                },
                results: [
                    'Выбранное стилистическое решение: шрифты,цвета, key visual и др.;',
                    'Базовый UI Kit.',
                ],
                risks: [
                    'Визуальное несоответствие целевой аудитории, неузнаваемость среди конкурентов, неактуальность.',
                ],
            },
            {
                name: 'Создание макетов',
                price: {
                    from: 'От 600 т.р.',
                    to: 'до 2,9 млн.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: 'Финальный этап перед разработкой, проработка UI на основе user screen flow или прототипа.',
                    [typesStageSubPhase.whyNeeded]: 'Для создания удобного и современного интерфейса продукта и для эффективной разработки.',
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Выстраивает полную картину продукта с UX/UI и создает гайдлайн для работы на протяжении всего пути.',
                    [typesStageSubPhase.whatResultStage]: ['Готовые макеты для передачи в разработку.'],
                },
                results: [
                    'Проработанный User Flow и Warftame;',
                    'Макеты, включающие все сценарии приложения;',
                    'Библиотека компонентов;',
                    'Подготовленные анимации.',
                ],
                risks: [
                    'Разработка продукта без макетов занимает минимум в 2 раза больше времени;',
                    'Не user-friendly результат снизит конкурентоспособность.',
                ],
            },
        ],
    },
    {
        name: 'Разработка MVP',
        description: 'Создание первой версии продукта для тестирования основных сценариев',
        subPhases: [
            {
                name: 'ТЗ на MVP',
                price: {
                    from: 'От 0 т.р.',
                    to: 'до 190 т.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: 'ТЗ на MVP – основной формальный документ, который регламентирует, что должно быть сделано по результатам каждого этапа.',
                    [typesStageSubPhase.whyNeeded]: 'Этот этап нужен для формализации обязательства команды разработки. ТЗ фиксирует все существенные требования по разработке продукта.',
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Хорошее ТЗ исключает возможность двоякого толкования задачи. Каждый элемент должен быть описан так, что все стороны понимают, как это будет выглядеть в итоге.',
                    [typesStageSubPhase.whatResultStage]: 'Техническое задание на MVP.',
                },
                results: [
                    'Техническое задание на MVP;',
                    'План разработки;',
                    'Технические требования к разработке;',
                    'Макеты дизайна.',
                ],
                risks: [
                    'Если документ составлен непрофессионально и без должного внимания, результат окажется некачественным и не функциональным.',
                ],
            },
            {
                name: 'Итерационная разработка + CustDev',
                price: {
                    from: 'От 300 т.р.',
                    to: 'до 2 млн.р. за итерацию',
                },
                stages: {
                    [typesStageSubPhase.descriptionCustDev]: {
                        noPoints: true,
                        text: ['Максимально быстрые и недорогие:', '1) поиск клиентов и ценности;', '2) проверка, что клиенты готовы платить за найденную ценность;', '3) проверка, что команда способна создать ценность без существенных инвестиций.'],
                    },
                    [typesStageSubPhase.descriptionIterDev]: 'Основной инструмент управления разработкой продукта в условиях меняющихся требований. Эффективен, когда в ходе разработки появляется новая информация, которая может существенно сказаться на итоговом облике продукта.',
                    [typesStageSubPhase.whyNeeded]: 'CustDev помогает максимально быстро и недорого найти клиентов и определить ценности продукта. Позволяет проверить сколько клиенты готовы платить за найденную и предложенную им ценность.',
                    [typesStageSubPhase.hasStageAffectsProduct]: {
                        noPoints: true,
                        text: ['1) Максимально точный поиск бизнес-модели продукта;', '2) Поиск ЦА, выявление её боли и Value Proposition от которого невозможно отказаться.'],
                    },
                    [typesStageSubPhase.whatResultStage]: {
                        noPoints: true,
                        text: ['1) Сегментированная ЦА, карта болей, ценностное предложение для каждого сегмента;', '2) Эволюционный прототип.'],
                    },
                },
                results: [
                    'Бизнес-модель будущего продукта;',
                    'Детальный план разработки и эволюционный прототип;',
                    'Спроектированная архитектура.',
                    // 'Бэклог задача по верстке, дизайну и каждой User Story;',
                    // 'Разработанный программный продукт;',
                    // 'План тестирования.',
                ],
                risks: [
                    'Продукт не нужен ЦА;',
                    'Нет программного продукта.',
                ],
            },
        ],
    },
    {
        name: 'Тестирование',
        description: 'Привлечение потенциальных клиентов',
        subPhases: [
            {
                name: 'Конкуренты, аналоги, бенчмарки',
                price: {
                    from: 'От 350 т.р.',
                    to: 'до 900 т.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: 'Анализ конкурентного окружения, выделение трендов и лучших практик, оценка рынка готовых решений, сегментация конкурентов. \nФокус на имеющемся продукте, дополнительной коммуникации и как об этом говорят конкуренты.',
                    [typesStageSubPhase.whyNeeded]: 'Понять решения на рынке помогут улучшить продукт. Как они удовлетворяют потребности пользователей. Приоритизировать процесс разработки и понять, что необходимо, а что опционально.',
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Позволяет понять необходимое функциональное наполнение продукта, приоритизировать бэклог, отстроиться от конкурентов в продуктовом плане.',
                    [typesStageSubPhase.whatResultStage]: 'Библиотека работающих решений и кейсов конкурентов;\nКарта лучших практик и трендов;\nСравнение конкурентов по функциям продукта и коммуникационным параметрам.',
                },
                results: [
                    'Результаты бенчмаркинга клиентов по функциональности.',
                ],
                risks: [
                    'Решение неактуально или не уникально для рынка, либо использование нетрендовых механик. Непонимание общей картины рынка.',
                ],
            },
            {
                name: 'Канал трендов',
                price: {
                    from: 'От 100 т.р.',
                    to: 'до 500 т.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: {
                        noPoints: true,
                        text: ['Создание информационной среды, которая позволяет на регулярной основе отслеживать и анализировать:', '-&nbsp;Обновления и запуски продуктов конкурентов;', '-&nbsp;Тренды в своей и смежных индустриях;', '-&nbsp;Лучшие практики и действия рынка.'],
                    },
                    [typesStageSubPhase.whyNeeded]: 'Чтобы понимать, как изменяется рынок и что делают конкуренты, прогнозировать, как рынок будет выглядеть завтра.',
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Общее информационное поле для всех, кто работает над продуктом — все в курсе лучших практик, передовых продуктовых механик и актуальных данных о рынке.',
                    [typesStageSubPhase.whatResultStage]: 'Регулярные (ежедневные/еженедельные) апдейты о рынке.',
                },
                results: [
                    'Единая информационная среда для всей команды;',
                    'Постоянное отслеживание обновлений в продуктах конкурентов.',
                ],
                risks: [
                    'Решение будет не уникальным для рынка или не трендовым. Продукт не будет вовремя адаптирован и быстро утратит актуальность.',
                ],
            },
            {
                name: 'Брендинг',
                price: {
                    from: 'От 1 млн.р.',
                    to: 'до 1,5 млн.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: 'Разработка позиционирования, коммуникационной стратегии продукта.',
                    [typesStageSubPhase.whyNeeded]: 'Жизненно важный этап для вывода продукта на рынок.',
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Обеспечит узнаваемость, запоминаемость, отличит от конкурентов в глазах потребителей.',
                    [typesStageSubPhase.whatResultStage]: 'Позиционирование, коммуникационная стратегия продукта.',
                },
                results: [
                    'Позиционирование продукта;',
                    'Название и логотип продукта.',
                ],
                risks: [
                    'Есть шанс, что люди не поймут как или зачем пользоваться вашим продуктом.',
                ],
            },
        ],
    },
    {
        name: 'запуск',
        description: 'CustDev, исследования и итерационная разработка',
        subPhases: [
            {
                name: 'Итерационная разработка + CustDev',
                price: {
                    from: 'От 300 т.р.',
                    to: 'до 2 млн.р. за итерацию',
                },
                stages: {
                    [typesStageSubPhase.descriptionCustDev]: {
                        noPoints: true,
                        text: ['Максимально быстрые и недорогие:', '1) поиск клиентов и ценности;', '2) проверка, что клиенты готовы платить за найденную ценность;', '3) проверка, что команда способна создать ценность без существенных инвестиций.'],
                    },
                    [typesStageSubPhase.descriptionIterDev]: 'Основной инструмент управления разработкой продукта в условиях меняющихся требований. Эффективен, когда в ходе разработки появляется новая информация, которая может существенно сказаться на итоговом облике продукта.',
                    [typesStageSubPhase.whyNeeded]: 'CustDev помогает максимально быстро и недорого найти клиентов и определить ценности продукта. Позволяет проверить сколько клиенты готовы платить за найденную и предложенную им ценность.',
                    [typesStageSubPhase.hasStageAffectsProduct]: {
                        noPoints: true,
                        text: ['1) Максимально точный поиск бизнес-модели продукта;', '2) Поиск ЦА, выявление её боли и Value Proposition от которого невозможно отказаться.'],
                    },
                    [typesStageSubPhase.whatResultStage]: {
                        noPoints: true,
                        text: ['1) Сегментированная ЦА, карта болей, ценностное предложение для каждого сегмента;', '2) Эволюционный прототип.'],
                    },
                },
                results: [
                    'Бизнес-модель будущего продукта;',
                    'Детальный план разработки и эволюционный прототип;',
                    'Спроектированная архитектура.',
                    // 'Бэклог задача по верстке, дизайну и каждой User Story;',
                    // 'Разработанный программный продукт;',
                    // 'План тестирования.',
                ],
                risks: [
                    'Продукт не нужен ЦА;',
                    'Нет программного продукта.',
                ],
            },
            {
                name: 'Он-деманд исследования',
                price: {
                    from: 'От 350 т.р.',
                    to: 'до 1 млн.р.',
                },
                stages: {
                    [typesStageSubPhase.description]: 'Детальный анализ реализаций конкретных механик в продукте у конкурентов или на рынке, выявление лучших практик.',
                    [typesStageSubPhase.whyNeeded]: 'Разработать оптимальную с точки зрения удобства и функциональности механику.',
                    [typesStageSubPhase.hasStageAffectsProduct]: 'Риск больших затрат на создание решения, которое уже есть на рынке, или разработку неактуальной и не трендовой механики.',
                    [typesStageSubPhase.whatResultStage]: 'Оптимально разработанный продукт.',
                },
                results: [
                    '-',
                    '-',
                    '-',
                ],
                risks: [
                    'Решение неактуально или не уникально для рынка, использованы нетрендовые механики;',
                    'Непонимание общей картины рынка.',
                ],
            },
        ],
    },
];
